import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {SessionService} from '../services/session.service';

@Injectable({
  providedIn: 'root',
})
export class MustBeLoggedOutGuardGuard  {
  constructor(
    private session: SessionService,
  ) {
  }


  private ensureNoSession(): boolean | Observable<boolean> {
    if (this.session.hasAuthenticated()) {
      this.session.logOut(false);
      return true;
    } else {
      return true;
    }
  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.ensureNoSession();
  }


  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.ensureNoSession();
  }
}
